import { get } from 'lodash';

const styles = ({ margin, padding, color }) => ({
  statusIcon: {
    height: 15,
    marginRight: 3,
    width: 15,
  },
  listContent: {
    margin: get(margin, 'm0'),
  },
  pageBodyClass: {
    paddingTop: get(padding, 'p0'),
  },
  pageFilterAndSortClass: {
    marginTop: get(margin, 'm24'),
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginRight: '5px !important',
  },
  selectField: {
    padding: '2px 10px !important',
  },
  helpIcon: {
    color: get(color, 'primaryButtonBackground'),
    marginLeft: 6,
    marginTop: 3,
    height: 16,
    width: 16,
  },
  helpIconContainer: {
    display: 'flex',
  },
});

export default styles;
